import { render, staticRenderFns } from "./MenuTabNew.vue?vue&type=template&id=05a77ea1&scoped=true&"
import script from "./MenuTabNew.vue?vue&type=script&lang=js&"
export * from "./MenuTabNew.vue?vue&type=script&lang=js&"
import style0 from "./MenuTabNew.vue?vue&type=style&index=0&id=05a77ea1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a77ea1",
  null
  
)

export default component.exports